import { render, staticRenderFns } from "./sideBarMenuItem.vue?vue&type=template&id=357836b0&scoped=true&lang=pug&"
import script from "./sideBarMenuItem.vue?vue&type=script&lang=ts&"
export * from "./sideBarMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./sideBarMenuItem.vue?vue&type=style&index=0&id=357836b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357836b0",
  null
  
)

export default component.exports